module.exports = __webpack_public_path__ + "static/media/5.05a73ac9.png";